
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import H4 from '../../components/Typography/H4';
import Button from '../../components/Button';
import routes from '../../setup/routes';
import TabComponent from '../../components/Tab';
import MetricsToAccountingTerms from './MetricsToAccountingTerms';


const Settings: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${routes.SETTINGS_METRICS_TO_ACCOUNTING_TERM}`);
  };

  return (
    <div className='flex flex-col p-8 bg-white'>
        <div className="flex justify-between mb-8 text-white">
            <H4>Settings Page</H4>
        </div>
        <div className="flex w-full">
            <TabComponent tabs={[{label: 'Metrics To Accounting Terms', content: <MetricsToAccountingTerms />}]}/>
        </div>
    </div>
  );
};

export default Settings;
